import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RoutePageConfigurations } from "../../configuration";
import { shouldShowBranchSelection } from "../../utils";

export const CurrentBranchRoute = ({ children, }: { children: React.ReactNode; }) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (shouldShowBranchSelection()) {
            navigate(RoutePageConfigurations.miscellaneous.currentBranchPage);
        }
    }, []);
    return <>{children}</>;
}